// extracted by mini-css-extract-plugin
module.exports = {"container":"tag-container__2OCax","label":"tag-label__yt05t","disabled":"tag-disabled__1qmyg","tag_target_loading":"tag-tag_target_loading__3MFNV"};